import React from "react";
import Section1 from "../../components/AboutUs/Section1";
import Section2 from "../../components/AboutUs/Section2New";
// import TeamRAT from "../../components/AboutUs/TeamRAT";
import Stats from "../../components/AboutUs/Stats";
import Section4 from "../../components/AboutUs/Section4";
import Section5 from "../../components/AboutUs/Section5";
import OurPartnerStatic from "../../components/OurPartnerStatic";
import Awards from "../../components/Awards";
import { aboutUsPartners } from "../../assets/PartnersNew";
import { awards } from "../../assets/award";

export const AboutUs = () => {
  return (
    <div className="relative w-full overflow-hidden">
      <Section1 />
      <Section2 />
      <Stats />
      {/* <TeamRAT /> */}
      {/*for commit  */}
      {/* <Section4 /> */}
      <OurPartnerStatic heading={"our partners"} partners={aboutUsPartners} />
      {/* <Section5 /> */}
      <Awards heading={"awards"} awards={awards} />
    </div>
  );
};

export default AboutUs;
